import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/features/auth/hooks/use-auth";
import { LoadingSpinner } from "@/components/ui/loading-spinner";

/** Redirect authenticated users away from public-only routes (login). */
export function PublicRoute() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-page flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (user) {
    return (
      <Navigate
        to={user.requiresPasswordChange ? "/change-password" : "/schedules"}
        replace
      />
    );
  }
  return <Outlet />;
}
